import type {BannerType} from '@github-ui/custom-properties-types'
import {Banner} from '@primer/react'
import {AriaAlert} from '@primer/react/experimental'

import {useBannerContext} from '../context/BannerContext'

const bannerMessagesMap: Record<BannerType, string> = {
  'definition.created.success': 'Property definition successfully created.',
  'definition.updated.success': 'Property definition successfully updated.',
  'definition.deleted.success': 'Property definition successfully deleted.',
  'definition.promotion.success': 'Property successfully promoted.',
  'values.updated.success': 'Properties updated successfully.',
}

interface Props {
  className?: string
}

export function PageBanner({className}: Props) {
  const {banner, setBanner, bannerRef} = useBannerContext()

  if (!banner) return null

  return (
    <Banner
      ref={bannerRef}
      title="Property update information"
      variant="success"
      onDismiss={() => setBanner(null)}
      hideTitle
      className={className}
      description={<AriaAlert>{bannerMessagesMap[banner]}</AriaAlert>}
    />
  )
}
